import { put, takeLatest, select, call } from "redux-saga/effects";
import * as types from "./types";
import * as actions from "./actions";
import { getReportsRequest } from "../Reports/actions";

function* fetchReportListSaga(action) {
  const { id } = action.payload;
  const { page, rowCount } = yield select((state) => state.persistReport);
  yield put(
    getReportsRequest({
      id,
      params: {
        page,
        items: rowCount,
      },
    })
  );
}

function* initialFetchReport(action) {
  try {
    yield call(fetchReportListSaga, action);
  } catch (error) {
    console.log(error);
  }
}

function* reportPagesSaga(action) {
  try {
    const { page } = yield select((state) => state.persistReport);
    if (action.payload !== page) {
      yield put(actions.setReportPage(action.payload));
      yield call(fetchReportListSaga);
    }
  } catch (error) {
    console.log(error);
  }
}

function* reportRowsSaga(action) {
  try {
    const { rowCount } = yield select((state) => state.persistReport);
    if (action.payload !== rowCount) {
      yield put(actions.setReportRow(action.payload));
      yield call(fetchReportListSaga);
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* persistReportSaga() {
  yield takeLatest(types.INITIAL_FETCH_REPORT, initialFetchReport);
  yield takeLatest(types.SET_REPORT_PAGE, reportPagesSaga);
  yield takeLatest(types.SET_REPORT_ROW, reportRowsSaga);
}
